/* Wallet Studio — native Shopify cart and product artwork lightbox. */
(() => {
  'use strict';
  if (window.__wsCommerceInitialized) return;
  window.__wsCommerceInitialized = true;

  const zoomers = document.querySelectorAll('[data-ws-zoom-src]');
  const dialog = document.querySelector('[data-ws-image-lightbox]');
  if (dialog) {
    const enlarged = dialog.querySelector('[data-ws-lightbox-image]');
    const caption = dialog.querySelector('[data-ws-lightbox-caption]');
    const close = dialog.querySelector('[data-ws-lightbox-close]');
    zoomers.forEach(trigger => {
      trigger.addEventListener('click', () => {
        const src = trigger.dataset.wsZoomSrc;
        if (!src || !enlarged) return;
        if (typeof dialog.showModal !== 'function') {
          window.open(src, '_blank', 'noopener');
          return;
        }
        enlarged.src = src;
        enlarged.alt = trigger.querySelector('img')?.alt || trigger.dataset.wsZoomTitle || 'Diseño de tarjeta';
        if (caption) caption.textContent = trigger.dataset.wsZoomTitle || 'Diseño de tarjeta';
        dialog.showModal();
        close?.focus();
      });
    });
    close?.addEventListener('click', () => dialog.close());
    dialog.addEventListener('click', event => {
      if (event.target === dialog) dialog.close();
    });
    dialog.addEventListener('close', () => {
      if (enlarged) enlarged.removeAttribute('src');
    });
  }

  document.querySelectorAll('.ws-shopify-cart-form').forEach(form => {
    form.addEventListener('submit', async event => {
      if (!window.fetch || !window.FormData) return; // Native Shopify form fallback.
      event.preventDefault();
      const button = form.querySelector('[data-ws-cart-submit]');
      const error = form.querySelector('[data-ws-cart-error]');
      if (button?.disabled) return;
      if (error) { error.textContent = ''; error.hidden = true; }
      if (button) { button.disabled = true; button.setAttribute('aria-busy', 'true'); }
      const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      const endpoint = root.replace(/\/?$/, '/') + 'cart/add.js';
      try {
        const response = await window.fetch(endpoint, {
          method: 'POST',
          body: new window.FormData(form),
          headers: {'Accept': 'application/json'}
        });
        if (!response.ok) {
          const problem = await response.json().catch(() => ({}));
          throw new Error(problem.description || problem.message || 'No se pudo añadir el producto al carrito.');
        }
        window.location.assign(form.dataset.wsCartUrl || root.replace(/\/?$/, '/') + 'cart');
      } catch (err) {
        if (error) {
          error.textContent = err.message || 'Error de conexión. Comprueba el carrito antes de intentarlo de nuevo.';
          error.hidden = false;
        }
        if (button) { button.disabled = false; button.removeAttribute('aria-busy'); }
      }
    });
  });
})();